import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManageSession } from '../services/manage-session';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private pendingRequests = 0;
  private readonly loaderExcludedPaths = ['/batch_integration/status/'];

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly sessionSvc: ManageSession,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const shouldShowLoader = !this.shouldSkipLoader(req.url);
    if (shouldShowLoader) {
      this.startLoader();
    }

    const token = this.sessionSvc.getAuthToken();
    const authReq = token
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error)),
      finalize(() => {
        if (shouldShowLoader) {
          this.stopLoader();
        }
      }),
    );
  }

  private shouldSkipLoader(url: string): boolean {
    return this.loaderExcludedPaths.some((path) => url.includes(path));
  }

  private startLoader(): void {
    this.pendingRequests += 1;
    if (this.pendingRequests === 1) {
      this.spinner.show();
    }
  }

  private stopLoader(): void {
    this.pendingRequests = Math.max(this.pendingRequests - 1, 0);
    if (this.pendingRequests === 0) {
      this.spinner.hide();
    }
  }
}
